/*! js-cookie v3.0.5 | MIT */
!function(e,t){"object"==typeof exports&&"undefined"!=typeof module?module.exports=t():"function"==typeof define&&define.amd?define(t):(e="undefined"!=typeof globalThis?globalThis:e||self,function(){var n=e.Cookies,o=e.Cookies=t();o.noConflict=function(){return e.Cookies=n,o}}())}(this,(function(){"use strict";function e(e){for(var t=1;t<arguments.length;t++){var n=arguments[t];for(var o in n)e[o]=n[o]}return e}var t=function t(n,o){function r(t,r,i){if("undefined"!=typeof document){"number"==typeof(i=e({},o,i)).expires&&(i.expires=new Date(Date.now()+864e5*i.expires)),i.expires&&(i.expires=i.expires.toUTCString()),t=encodeURIComponent(t).replace(/%(2[346B]|5E|60|7C)/g,decodeURIComponent).replace(/[()]/g,escape);var c="";for(var u in i)i[u]&&(c+="; "+u,!0!==i[u]&&(c+="="+i[u].split(";")[0]));return document.cookie=t+"="+n.write(r,t)+c}}return Object.create({set:r,get:function(e){if("undefined"!=typeof document&&(!arguments.length||e)){for(var t=document.cookie?document.cookie.split("; "):[],o={},r=0;r<t.length;r++){var i=t[r].split("="),c=i.slice(1).join("=");try{var u=decodeURIComponent(i[0]);if(o[u]=n.read(c,u),e===u)break}catch(e){}}return e?o[e]:o}},remove:function(t,n){r(t,"",e({},n,{expires:-1}))},withAttributes:function(n){return t(this.converter,e({},this.attributes,n))},withConverter:function(n){return t(e({},this.converter,n),this.attributes)}},{attributes:{value:Object.freeze(o)},converter:{value:Object.freeze(n)}})}({read:function(e){return'"'===e[0]&&(e=e.slice(1,-1)),e.replace(/(%[\dA-F]{2})+/gi,decodeURIComponent)},write:function(e){return encodeURIComponent(e).replace(/%(2[346BF]|3[AC-F]|40|5[BDE]|60|7[BCD])/g,decodeURIComponent)}},{path:"/"});return t}));

const consent = function () {
	const getModal      = function () { return document.querySelector('.cookie-consent'); };
	const getModalHTML  = function () { return document.querySelector('#cookie-consent'); };
	const getBt         = function () { return document.querySelector('.cookie-bt'); };
	const getAnalytics  = function () { return document.querySelector('#cookie-statistics-optin'); };
	const getMarketing  = function () { return document.querySelector('#cookie-marketing-optin'); };
	const getBlockedMsg = function () {
		if (document.querySelector('html').getAttribute('lang').indexOf('fr') === 0) {
			return 'Veuillez cliquer pour accepter les témoins et accéder au contenu.';
		} else {
			return 'Please click to accept cookies and access content.';
		}
	};
	const cookieName    = 'loi25';
	const init = function () {
		window.addEventListener('load', function () {
			checkCookie();
			getBt()?.addEventListener('click', showModal);
		});
	};
	/**
	 * check current cookie status
	 */
	const checkCookie = function () {
		const cookie = Cookies.get(cookieName);
		if (!cookie) {
			showModal();
			deleteCookies();
		} else {
			showBt();
		}

		// block content
		if (!cookie || cookie === 'deny' || cookie === 'marketing') {
			deleteCookies();
			setupContentBlock('analytics');
		}
		if (!cookie || cookie === 'deny' || cookie === 'analytics') {
			setupContentBlock('marketing');
		}

		// update body class status
		document.body.classList.add('-consent-' + cookie);
	};
	/**
	 * check correct input based on cookie
	 */
	const setInputs = function () {
		const cookie = Cookies.get(cookieName);

		if (cookie === 'analytics' || cookie === 'all') {
			if (getAnalytics()) { getAnalytics().checked = true; }
		} else {
			if (getAnalytics()) { getAnalytics().checked = false; }
		}
		if (cookie === 'marketing' || cookie === 'all') {
			if (getMarketing()) { getMarketing().checked = true; }
		} else {
			if (getMarketing()) { getMarketing().checked = false; }
		}
	};
	/**
	 * create modal html and add events
	 */
	const addModal = function () {
		const html = getModalHTML()?.content.cloneNode(true);
		if (html) {
			document.querySelector('body').prepend(html);
			getModal()?.querySelector('#bt-accept')?.addEventListener('click', e => setStatus('all'));
			getModal()?.querySelector('#bt-refuse')?.addEventListener('click',  e => setStatus('deny'));
			getModal()?.querySelector('#bt-pref')?.addEventListener('click', pref);
			getModal()?.querySelector('#bt-save')?.addEventListener('click', savePref);
		}
	};
	/**
	 * show modal
	 */
	const showModal = function () {
		hideBt();
		if (!getModal()) { addModal(); }
		if (!getModal()) { return; }
		setInputs();
		if (document.querySelector('.-no-dialog')) {
			getModal().style.display = 'block';
		} else {
			getModal().show();
		}
		getModal().setAttribute('aria-hidden', 'false');
	};
	/**
	 * hide modal
	 */
	const hideModal = function () {
		if (!getModal()) { return; }
		if (document.querySelector('.-no-dialog')) {
			getModal().style.display = 'none';
		} else {
			getModal().close();
		}
		getModal().remove();
	};
	/**
	 * show modal bt
	 */
	const showBt = function () {
		hideModal();
		if (!getBt()) { return; }
		getBt().style.display = 'block';
		getBt().setAttribute('aria-hidden', 'false');
	};
	/**
	 * hide modal bt
	 */
	const hideBt = function () {
		if (!getBt()) { return; }
		getBt().style.display = 'none';
		getBt().setAttribute('aria-hidden', 'true');
	};
	/**
	 * show cookie pref
	 * @param  {[type]} e [description]
	 */
	const pref = function (e) {
		getModal().querySelector('#bt-pref').style.display = 'none';
		getModal().querySelector('#bt-save').style.display = 'inline-block';
		getModal().querySelector('.cookie-manage-consent-container').style.display = 'block';
		getModal().querySelector('details').focus();
	};
	/**
	 * set cookie value
	 * @param {[type]} e    [description]
	 */
	const setStatus = function (type) {
		const cookie = Cookies.get(cookieName);

		if (
			type === 'all'
			|| (cookie === 'analytics' && type === 'marketing')
			|| (cookie === 'marketing' && type === 'analytics')
		) {
			Cookies.set(cookieName, 'all', { expires: 365 });
			setShopifyConsent(true, true, reload);
			// reload();
		}
		if (type === 'analytics' || type === 'marketing') {
			Cookies.set(cookieName, type, { expires: 365 });
			if (type === 'analytics') {
				setShopifyConsent(true, false, reload);
				// reload();
			} else {
				setShopifyConsent(false, true, reload);
				// reload();
			}
		}
		if (type === 'deny') {
			Cookies.set(cookieName, type, { expires: 365 });
			setShopifyConsent(false, false);
			showBt();
		}
		hideModal();

		const event = new CustomEvent('cookieUpdate', {detail: {type: type}});
		document.dispatchEvent(event);
	};
	const reload = function () {
		window.location.reload();
	};
	/**
	 * save preferences
	 * @param  {[type]} e [description]
	 */
	const savePref = function (e) {
		// accept
		if (getAnalytics()?.checked && getMarketing()?.checked) {
			setStatus('all');
			return;
		}

		// analytics only
		if (getAnalytics()?.checked) {
			setStatus('analytics');
			return;
		}

		// marketing only
		if (getMarketing()?.checked) {
			setStatus('marketing');
			return;
		}

		// deny
		getModal().querySelector('#bt-pref').style.display = 'inline-block';
		getModal().querySelector('#bt-save').style.display = 'none';
		getModal().querySelector('.cookie-manage-consent-container').style.display = 'none';
		setStatus('deny');
	};
	/**
	 * add event and content in blocked zones
	 * @param  {[type]} type [description]
	 */
	const setupContentBlock =  function (type) {
		let containers = [];
		if (type == 'analytics') {
			containers = [];
		}
		if (type == 'marketing') {
			containers = [
				// '#store-map'
			];
		}

		if (containers.length > 0) {
			document.querySelectorAll(containers).forEach(el => {
				el.classList.add('-blocked');
				el.innerHTML = '<span>' + getBlockedMsg() + '</span>';
				el.addEventListener('click', e => setStatus(type));
			});
		}
	};
	/**
	 * delete extra cookie for Shopify
	 */
	const deleteCookies = function () {
		setTimeout(function () {
			toDelete = [
				'_landing_page',
				'_orig_referrer',
				'_s',
				'_shopify_d',
				'_shopify_fs',
				'_shopify_s',
				'_shopify_sa_p',
				'_shopify_sa_t',
				'_shopify_y',
				'_y',
				'_shopify_ga',
				'customer_auth_provider',
				'customer_auth_session_created_at',
				'unique_interaction_id'
			];
			toDelete.forEach(function (name) {
				Cookies.remove(name, { path: '/', domain: '.' + window.location.host });
			});
		}, 1000);
	};
	/**
	 * send cookie pref to Shopify consent API
	 * @param {[type]}   analytics [description]
	 * @param {[type]}   marketing [description]
	 * @param {Function} fn        [description]
	 */
	const setShopifyConsent = function (analytics, marketing, fn) {
		if (typeof window.Shopify.customerPrivacy !== 'undefined') {
			window.Shopify.customerPrivacy.setTrackingConsent(
				{
					"analytics"    : analytics,
					"marketing"    : marketing,
					"preferences"  : true,
					"sale_of_data" : false,
				},
				() => {
					if (typeof fn === 'function') {
						fn();
					}
				}
			);
		} else {
			if (typeof fn === 'function') {
				fn();
			}
		}
	};

	window.addEventListener('DOMContentLoaded', e => {
		if (window.Shopify) {
			window.Shopify.loadFeatures(
				[
					{
						name   : 'consent-tracking-api',
						version: '0.1',
					}
				],
				error => {
					if (error) {}
					if (!Cookies.get(cookieName)) {
						setShopifyConsent(false, false);
					}
				}
			);
		}
	});

	init();
}();

const cookie25 = Cookies.get('loi25');

/**
 * check if cookies need to be blocked
 * @param  {[type]} src  [description]
 * @param  {[type]} type [description]
 * @return {[type]}      [description]
 */
const needsToBeBlacklisted = function (src, type) {
	let block       = false;
	let blocked     = [];
	const analytics = [
		// 'googletagmanager',
		// 'google-analytics.com',
		'clarity.ms',
		'shopify-boomerang',
		'hotjar.com',
		'mouseflow',
		'static-tracking.klaviyo.com'
	];
	const marketing = [
		'connect.facebook.net',
		'maps.google.com'
	];

	src = src || '';

	// all blocked
	if (!cookie25 || cookie25 === 'deny') {
		blocked = blocked.concat(marketing);
		blocked = blocked.concat(analytics);
	}
	// block marketing
	if (cookie25 === 'analytics') {
		blocked = blocked.concat(marketing);
	}
	// block analytics
	if (cookie25 === 'marketing') {
		blocked = blocked.concat(analytics);
	}

	blocked.forEach(function (el) {
		if (String(src).indexOf(el) !== -1) {
			block = true;
		}
	});
	return block;
};

/**
 * check all loaded javascript and block it if necessary
 * @param  {[type]} mutations [description]
 * @return {[type]}           [description]
 */
const scriptObserver = new MutationObserver (mutations => {
	mutations.forEach(({ addedNodes }) => {
		addedNodes.forEach(node => {
			if (node.nodeType === 1 && node.tagName === 'SCRIPT') {
				const src  = node.src || '';
				const type = node.type;

				if (needsToBeBlacklisted(src, type)) {
					node.type = 'javascript/blocked';
					node.parentElement.removeChild(node);

					const beforeScriptExecuteListener = function (e) {
						// Prevent only marked scripts from executing
						if(node.getAttribute('type') === 'javascript/blocked') {
							e.preventDefault();
						}
						node.removeEventListener('beforescriptexecute', beforeScriptExecuteListener);
					}
					node.addEventListener('beforescriptexecute', beforeScriptExecuteListener);
				}
			}
			if (node.nodeType === 1 && node.tagName === 'LINK') {
				const rel  = node.rel || '';
				const type = node.type;

				if (rel === 'stylesheet' && needsToBeBlacklisted(rel, type)) {
					node.rel = 'stylesheet/blocked';
					node.parentElement.removeChild(node);

					const beforeScriptExecuteListener = function (e) {
						// Prevent only marked scripts from executing
						if(node.getAttribute('rel') === 'stylesheet/blocked') {
							e.preventDefault();
						}
						node.removeEventListener('beforescriptexecute', beforeScriptExecuteListener);
					}
					node.addEventListener('beforescriptexecute', beforeScriptExecuteListener);
				}
			}
			if (node.nodeType === 1 && node.tagName === 'IFRAME') {
				const src  = node.src || '';

				if (needsToBeBlacklisted(src, false)) {
					node.src = '';
					node.classList.add('blocked');
				}
			}
		})
	});
});

if (!cookie25 || cookie25 !== 'all') {
	scriptObserver.observe(document.documentElement, {
		childList: true,
		subtree  : true
	});
}

const createElementBackup = document.createElement;
// block scripts and links
document.createElement = function(...args) {
	if(args[0].toLowerCase() !== 'script' && args[0].toLowerCase() !== 'link') {
		return createElementBackup.bind(document)(...args);
	}
	const scriptEl = createElementBackup.bind(document)(...args);

	const originalSetAttribute = scriptEl.setAttribute.bind(scriptEl);

	// Define getters / setters to ensure that the script type is properly set
	Object.defineProperties(scriptEl, {
		'src': {
			get() {
				return scriptEl.getAttribute('src');
			},
			set(value) {
				if (needsToBeBlacklisted(value, scriptEl.type)) {
					originalSetAttribute('type', 'javascript/blocked');
				}
				originalSetAttribute('src', value);
				return true;
			}
		},
		'href': {
			get() {
				return scriptEl.getAttribute('href');
			},
			set(value) {
				if(needsToBeBlacklisted(value, scriptEl.rel)) {
					originalSetAttribute('rel', 'stylesheet/blocked');
				}
				originalSetAttribute('href', value);
				return true;
			}
		},
		'type': {
			set(value) {
				const typeValue = needsToBeBlacklisted(scriptEl.src, scriptEl.type) ? 'javascript/blocked' : value;
				originalSetAttribute('type', typeValue);
				return true;
			}
		},
		'rel': {
			set(value) {
				const typeValue = needsToBeBlacklisted(scriptEl.href, scriptEl.rel) ? 'stylesheet/blocked' : value;
				originalSetAttribute('rel', typeValue);
				return true;
			}
		}
	});

	// Monkey patch the setAttribute function so that the setter is called instead.
	// Otherwise, setAttribute('type', 'whatever') will bypass our custom descriptors!
	scriptEl.setAttribute = function(name, value) {
		if(name === 'type' || name === 'src' || name === 'href' || name === 'rel') {
			scriptEl[name] = value;
		} else {
			HTMLScriptElement.protytope?.setAttribute.call(scriptEl, name, value);
		}
	}

	return scriptEl;
}
